import type { AuthenticationAccessRight } from "src/authentication/objects/AuthenticationToken";

export const AccountAccessRight = {
  VIEW_ACCOUNTS: ({ menuDisplayLevel }) => menuDisplayLevel === 0,
  VIEW_DEFAULT_WEBHOOKS: ({ menuDisplayLevel }) => menuDisplayLevel === 0,
} satisfies Record<string, AuthenticationAccessRight>;
